import * as React from 'react';
const SvgChevronLeft = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m11.9 12 2.458-2.455a.503.503 0 0 0 0-.7l-.7-.702a.5.5 0 0 0-.699 0l-3.167 3.156a.99.99 0 0 0 0 1.402l3.157 3.156a.5.5 0 0 0 .7 0l.699-.701c.19-.19.19-.511 0-.701L11.89 12z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgChevronLeft;
